import { render, staticRenderFns } from "./addData_2.vue?vue&type=template&id=c86a1772&scoped=true"
import script from "./addData_2.vue?vue&type=script&lang=js"
export * from "./addData_2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86a1772",
  null
  
)

export default component.exports